import React from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

// Keeps the active page tab in ?tab= (first key = default, no param).
export function useTabParam(keys) {
  const [params, setParams] = useSearchParams();
  const want = params.get("tab");
  const tab = keys.includes(want) ? want : keys[0];
  const setTab = (v) => setParams(v === keys[0] ? {} : { tab: v }, { replace: true });
  return [tab, setTab];
}

// tabs: [{ key, label, badge? }]. Hidden when only one tab is available. Shared by Daily Schedule + Team Members.
export default function ScheduleTabs({ tabs, value, onChange, testId = "schedule" }) {
  if (tabs.length < 2) return null;
  return (
    <Tabs value={value} onValueChange={onChange} className="mb-5">
      <TabsList className="max-w-full justify-start overflow-x-auto" data-testid={`${testId}-tabs`}>
        {tabs.map(({ key, label, badge }) => (
          <TabsTrigger key={key} value={key} data-testid={`${testId}-tab-${key}`}>
            {label}
            {badge > 0 && <span className="ml-1.5 rounded-full bg-orange-500 px-1.5 text-[11px] font-bold text-white tabular-nums" data-testid={`${testId}-tab-${key}-badge`}>{badge}</span>}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
